export default "__VITE_ASSET__BfpSHy5a__"